import { useMemo } from "react";
import { Box, Flex, Text } from "@chakra-ui/layout";
import { formatCurrency } from "@brazilian-utils/brazilian-utils";
import { AcordoItem } from "core/features/acordo/typings";
import { Tag } from "@chakra-ui/react";
import moment from "moment";
import TagStatusAcordo from "./../components/TagStatus";
import CustomTag from "ui/components/Tags/CustomTag";

function useListagemAcordoColumns() {
  return useMemo(() => {
    return [
      {
        title: "Criado em",
        width: "14%",
        render: (original: AcordoItem) => (
          <Flex gap={2} alignItems="center">
            <Flex textAlign="center">
              {original.createdAt
                ? moment(original.createdAt).format("DD/MM/YYYY")
                : ""}
            </Flex>
          </Flex>
        ),
      },
      {
        title: "Código",
        width: "5%",
        render: (original: AcordoItem) => (
          <Flex gap={2} alignItems="center">
            <Flex> {original.codigo ?? "--"}</Flex>
          </Flex>
        ),
      },
      {
        title: "Unidade",
        width: "15%",
        render: (original: AcordoItem) => (
          <Flex gap={2} alignItems="center">
            {original.unidade.blocoQuadra ? (
              <Flex mt="2px" fontSize="12px" fontWeight="bold">
                <Tag> {original.unidade.blocoQuadra}</Tag>
              </Flex>
            ) : null}

            <Flex> {original.unidade.numero}</Flex>
          </Flex>
        ),
      },
      {
        title: "Valor",
        width: "30%",
        render: (original: AcordoItem) => (
          <Box fontWeight="bold">R$ {formatCurrency(original.valor || 0)}</Box>
        ),
      },
      {
        title: "Situação",
        width: "50%",
        render: (original: AcordoItem) => (
          <Flex gridGap="8px" alignItems="center" flexDir="row">
            <TagStatusAcordo
              status={original.status}
              dataCancelamento={original.dataCancelamento}
            />

            {original.dataPagamento ? (
              <Text>
                Pago em {moment(original.dataPagamento).format("DD/MM/YYYY")}
              </Text>
            ) : null}

            {original.diasEmAtraso ? (
              <Text color="red">
                Com atraso de {original.diasEmAtraso} dia
                {original.diasEmAtraso === 1 ? "" : "s"}
              </Text>
            ) : null}

            {original.importado ? (
              <CustomTag h="30px" color="gray.500">
                Importado
              </CustomTag>
            ) : null}
          </Flex>
        ),
      },
    ];
  }, []);
}

export default useListagemAcordoColumns;
